var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('alert'),_c('router-view'),_c('not-found'),_c('report-expired'),_c('session-timeout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }